import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Table } from '@tfecom-thermofisher/react-komodo-design';

import { Message, Pagination, Visible } from 'src/core/components';

import messages from './messages';
import './TableStyle.scss';

export const TableComponent = ({
  id,
  data,
  config,
  onConfigChange,
  totalItems,
  onPaginationChange,
  setPagination,
  pagination,
}) => (
  <>
    <Table
      data={data}
      columns={config}
      onConfigChange={onConfigChange}
      size="large"
    />
    <Visible when={!data?.length}>
      <div data-testid={`${id}-table-no-data`} className="table-no-data">
        <Message message={messages.noTableDataDefault} literal />
      </div>
    </Visible>
    <Visible when={!!pagination}>
      <Pagination
        fetchNewResources={onPaginationChange}
        resourcesLength={totalItems}
        setPagination={setPagination}
        pagination={pagination}
      />
    </Visible>
  </>
);

TableComponent.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  config: PropTypes.array.isRequired,
  onConfigChange: PropTypes.func,
  totalItems: PropTypes.number,
  onPaginationChange: PropTypes.func,
  setPagination: PropTypes.func,
  pagination: PropTypes.object,
};

export default injectIntl(TableComponent);
